import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { filter, defaultTo, path, propEq, without, remove } from 'ramda';

import { handleErrorBase } from '../../util/forms';

import File from '../File';

class FileBrowser extends Component {
  static propTypes = {
    error: PropTypes.string,
    fake: PropTypes.bool,
    fileKey: PropTypes.string,
    files: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    label: PropTypes.string,
    fileType: PropTypes.string,
    name: PropTypes.string.isRequired,
    addFile: PropTypes.func,
    status: PropTypes.object,
    update: PropTypes.func,
  };

  static defaultProps = {
    fileType: 'Current Files',
  };

  constructor(props) {
    super(props);
    const files = defaultTo([], props.files);

    this.state = {
      files,
      currentFiles: filter(propEq('type', props.fileKey), files),
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const isFake = nextProps.fake;
    const oldFiles = defaultTo([], path(['files'], prevState));
    const newFiles = defaultTo([], path([isFake ? 'fakeFiles' : 'files'], nextProps));

    if (oldFiles.length != newFiles.length) {
      return { files: newFiles, currentFiles: newFiles.filter(propEq('type', nextProps.fileKey)) };
    }

    return null;
  }

  handleChange = (e) => {
    const { fake, files, fakeFiles, fakeUpdate, name, fileKey, addFile, update } = this.props;
    const uploadName = `${name}[]`;

    if (fake) {
      const newFiles = Array.from(e.target.files);
      const existingFiles = defaultTo([], files[uploadName]);

      return fakeUpdate({
        files: { ...files, [uploadName]: [...existingFiles, ...newFiles] },
        fakeFiles: [...fakeFiles, ...newFiles.map((file) => ({ name: file.name, type: fileKey }))],
      });
    }

    return addFile({ [uploadName]: e.target.files })
      .then((resp) => update(resp.data))
      .catch(() => handleErrorBase('Could not upload file.'));
  };

  fakeRemove = (index) => {
    const { files, fakeFiles, fakeUpdate, name } = this.props;
    const uploadName = `${name}[]`;
    const existingFiles = defaultTo([], files[uploadName]);

    return fakeUpdate({
      files: { ...files, [uploadName]: remove(index, 1, existingFiles) },
      fakeFiles: remove(index, 1, fakeFiles),
    });
  };

  render() {
    const { currentFiles } = this.state;
    const { error, fake, files, fileType, label, name, status, update } = this.props;
    const hasFiles = currentFiles.length > 0;
    const errorMsg = path(['errors', name], status) || error;

    return (
      <Fragment>
        {label && <label className="yellow-heading">{label}</label>}
        {hasFiles && (
          <h4>
            {fileType}:{' '}
            {currentFiles.map((file, i) => (
              <File
                fake={fake}
                key={file.id ? file.id : i}
                file={file}
                onDelete={() => (fake ? this.fakeRemove(i) : update(without([file], files)))}
              />
            ))}
          </h4>
        )}
        <div className="custom-file" lang="es">
          <input name={name} type="file" className="custom-file-input" onChange={this.handleChange} multiple />
          <label className="custom-file-label" htmlFor="exampleInputFile">
            {hasFiles ? 'Select another file...' : 'Select file(s)...'}
          </label>
        </div>
        {errorMsg && (
          <span className="invalid-feedback">
            <strong>{errorMsg}</strong>
          </span>
        )}
      </Fragment>
    );
  }
}

export default FileBrowser;
